import { ConsultationType } from '../types';
import { TopicIds } from '../constants/consultation-topic-id';

export interface BuildLinkProps {
  returnPage: string;
  consultationType: ConsultationType;
}

export function buildScheduleLink({
  returnPage,
  consultationType,
}: BuildLinkProps) {
  const type =
    consultationType === ConsultationType.LegalLabel
      ? 'attorney'
      : consultationType;
  return `/my/consultation/?returnPage=${returnPage}&consultationType=${type}` as const;
}

export function buildEmailLink({
  returnPage,
}: Pick<BuildLinkProps, 'returnPage'>) {
  return `/my/consultations?returnPage=${returnPage}` as const;
}

export function buildRescheduleLink(
  confirmationNumber: string,
  consultationType: string,
  returnPage: string,
  topicReferenceId?: string,
  accountId?: string,
  workItemId?: string,
) {
  const accountParam = accountId ? `&accountId=${accountId}` : '';
  const workItemIdParam = workItemId ? `&workItemId=${workItemId}` : '';
  if (consultationType && consultationType.toLowerCase() === 'tax') {
    return `/my/consultation/tax/reschedule?confirmationNumber=${confirmationNumber}&returnPage=${returnPage}${accountParam}` as const;
  }
  const consultationTypeParam = consultationType
    ? `&consultationType=${consultationType}`
    : '';
  return `/my/consultation/attorney/reschedule?confirmationNumber=${confirmationNumber}&returnPage=${returnPage}${accountParam}${workItemIdParam}${consultationTypeParam}` as const;
}
